import { HStack } from '@chakra-ui/react';

import { Badge, BADGE_COLORS } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { dateUtils } from 'shared_DEPRECATED/utils';

import {
  COLOR_BY_SESSION_ATTENDANCE_STATUS,
  SESSION_ATTENDANCE_LABEL,
} from 'features/sessions/config';
import { SessionAttendanceStatusType } from 'features/sessions/config/types';

import { Typography } from 'shared/components/Typography';

type CoachSessionsDateProps = {
  sessionDate: string;
  attendance: SessionAttendanceStatusType;
};

export const CoachSessionsDate = ({
  sessionDate,
  attendance,
}: CoachSessionsDateProps) => {
  return (
    <HStack gap={3}>
      <HStack>
        <Icon name={iconNames.calendar} width="14px" height="16px" />
        <Typography type="meta" color="black" dataTestid="sidebar-session-date">
          {dateUtils.localDate(sessionDate).format('MMM D, YYYY')}
        </Typography>
      </HStack>
      <Badge
        colorPalette={
          COLOR_BY_SESSION_ATTENDANCE_STATUS[attendance] as BADGE_COLORS
        }
      >
        <Typography
          type="small"
          color="whiteTotal"
          textTransform="uppercase"
          dataTestid="sidebar-session-attendance-cell"
        >
          {SESSION_ATTENDANCE_LABEL[attendance]}
        </Typography>
      </Badge>
    </HStack>
  );
};
